// The number of images ahead of the current slider to preload
const LOAD_AHEAD = 1;

const KEY_CODE = {
    ENTER: 13,
    SPACE_BAR: 32,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
};

const SLIDE_TYPE = {
    IMAGE: 'image',
    VIDEO: 'video',
    AUDIO: 'audio',
    PDF: 'pdf',
};

export { LOAD_AHEAD, KEY_CODE, SLIDE_TYPE };
